import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChartsModule } from '@carbon/charts-angular';
import { DragScrollModule } from 'cdk-drag-scroll';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ColorPickerModule } from 'ngx-color-picker';
import { LightboxModule } from 'ngx-lightbox';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { NodeTemplatePreviewModule } from './node-template-preview/node-template-preview.module';
import { PipesModule } from './pipes/pipes.module';
import { ProtocolDroidModule } from './services/protocol-droid/protocol-droid.module';
import { UiElementsModule } from './ui-elements/ui-elements.module';

import { AliasListComponent } from './components/alias-list/alias-list.component';
import { ScopeAliasListComponent } from './components/alias-list/scope-alias-list/scope-alias-list.component';
import { BaseDisplayComponent } from './components/bot-display/base-display/base-display.component';
import { BotDisplayComponent } from './components/bot-display/bot-display.component';
import { FeedbackMessageComponent } from './components/feedback/feedback-message/feedback-message.component';
import { FeedbackSpinnerComponent } from './components/feedback/feedback-spinner/feedback-spinner.component';
import { ModalBotItemActionComponent } from './components/modals/modal-bot-item-action/modal-bot-item-action.component';
import { ModalClustersInfoComponent } from './components/modals/modal-clusters-info/modal-clusters-info.component';
import { ModalEditClusterComponent } from './components/modals/modal-edit-cluster/modal-edit-cluster.component';
import { ModalEditDataKeyComponent } from './components/modals/modal-edit-data-key/modal-edit-data-key.component';
import { ModalSelectAliasComponent } from './components/modals/modal-select-alias/modal-select-alias.component';
import { ModalSelectBubbleComponent } from './components/modals/modal-select-bubble/modal-select-bubble.component';
import { ModalTwoOptionsComponent } from './components/modals/modal-two-options/modal-two-options.component';
import { NodeListComponent } from './components/node-list/node-list.component';
import { NodePreviewComponent } from './components/node-preview/node-preview.component';

@NgModule({
  imports: [
    BsDropdownModule,
    ColorPickerModule,
    CommonModule,
    DragDropModule,
    DragScrollModule,
    FormsModule,
    LightboxModule,
    NodeTemplatePreviewModule,
    PerfectScrollbarModule,
    PipesModule,
    PopoverModule,
    UiElementsModule,
    ProtocolDroidModule,
    ChartsModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollingModule,
    ExperimentalScrollingModule
  ],
  declarations: [
    BaseDisplayComponent,
    FeedbackMessageComponent,
    FeedbackSpinnerComponent,
    ModalClustersInfoComponent,
    ModalEditClusterComponent,
    ModalEditDataKeyComponent,
    ModalSelectBubbleComponent,
    ModalTwoOptionsComponent,
    ModalBotItemActionComponent,
    BotDisplayComponent,
    ModalSelectAliasComponent,
    NodeListComponent,
    AliasListComponent,
    ScopeAliasListComponent,
    NodePreviewComponent
  ],
  exports: [
    BsDropdownModule,
    ChartsModule,
    ColorPickerModule,
    CommonModule,
    DragDropModule,
    FormsModule,
    NodeTemplatePreviewModule,
    PerfectScrollbarModule,
    PipesModule,
    PopoverModule,
    UiElementsModule,
    ProtocolDroidModule,
    ReactiveFormsModule,
    RouterModule,
    BotDisplayComponent,
    DragScrollModule,
    NodeListComponent,
    AliasListComponent,
    ScopeAliasListComponent,
    NodePreviewComponent,
    ScrollingModule,
    ExperimentalScrollingModule
  ]
})
export class SharedModule {}
